/**
 * Adresse du lecteur d'un exercice. Un exercice SANS chapitre (exercices de
 * SKILLCARD générés sans cours, exercices d'épreuve) s'ouvre par
 * `/learn/exercise/$exercise` ; sinon par le chemin du chapitre. Avant, les
 * boutons « Commencer » / « Reprendre » ne faisaient RIEN pour un exercice sans
 * chapitre (ils renvoyaient `false` faute de chapitre).
 */

export interface ExerciseChapterRef {
  subject: string;
  level: string;
  slug: string;
}

export type ExerciseNavTarget =
  | {
      to: '/learn/$subject/$level/$chapter/$exercise';
      params: { subject: string; level: string; chapter: string; exercise: string };
    }
  | { to: '/learn/exercise/$exercise'; params: { exercise: string } };

export function exerciseNavTarget(
  exerciseId: string,
  chapter: ExerciseChapterRef | null | undefined,
): ExerciseNavTarget {
  if (chapter?.subject && chapter.level && chapter.slug) {
    return {
      to: '/learn/$subject/$level/$chapter/$exercise',
      params: {
        subject: chapter.subject,
        level: chapter.level,
        chapter: chapter.slug,
        exercise: exerciseId,
      },
    };
  }
  return { to: '/learn/exercise/$exercise', params: { exercise: exerciseId } };
}
